const issue = `api/Issue`;
const filter = `api/Filter`;
const user = `api/User/`;
const amended = `api/AmendedReturn`;
const asc = `api/ASC740`;
const keyword = `api/KeyWord/`;
const taxRate = `api/TaxRate/`;
const entity = `api/Entities/`;

export const TAX_ACCOUNTING_TAB_ENDPOINTS = {
  FILTER: {
    issueID: `api/Filter/GetIssueIds`,
    GET: `api/ASC740/GetFilterDetails`,
  },
  TAX_ACCOUNTING_LIST: {
    POST: `api/ASC740/GetASC740Details`,
  },
  EXCEL_DOWNLOAD: {
    POST: `api/ASC740/GetASC740ExportDetails`,
  },
  SAVE: {
    PUT: `api/ASC740/UpdateASC`,
  },
};

export const COMMON_API_ENDPOINTS = {
  AUDIT_TRAIL: {
    GET: `${issue}/GetAuditTrail`,
  },
  ISSUE: {
    GET_ID: `${issue}/GetIssueByIssueId`,
  },
  EXCEL: {
    POST_DOWNLOAD: `${asc}/GetASC740FilterExportDetails`,
  },
};

export const MAINTENANCE_TAB_ENDPOINTS = {
  ENTITES: {
    GET: `${entity}GetEntities`,
    ADD: `${entity}CreateEntity`,
    UPDATE: `${entity}UpdateEntity`,
    DELETE: `${entity}DeleteEntity`,
  },
  AUDIT_TRAIL: {
    GET: `api/AuditTrail/GetAuditTrails`,
  },
  KEYWORD: {
    GET: `${keyword}GetKeywords`,
    ADD: `${keyword}AddKeyword`,
    UPDATE: `${keyword}UpdateKeyword`,
    DELETE: `${keyword}DeleteKeyword`,
  },
  TAX_RATE: {
    GET: `${taxRate}GetTaxRates`,
    ADD: `${taxRate}AddTaxRate`,
    UPDATE: `${taxRate}UpdateTaxRate`,
    DELETE: `${taxRate}DeleteTaxRate`,
  },
};

export const USERS_TAB_ENDPOINTS = {
  USER: {
    GET: `${user}GetUserList`,
    ADD: `${user}CreateUser`,
    UPDATE: `${user}UpdateUser`,
    DELETE: `${user}DeleteUser`,
    DETAIL: `${user}GetUserDetails`,
  },
};

export const AMENDED_RETURN_TAB_ENDPOINTS = {
  GET: `${amended}/GetAmendedReturn`,
  UPDATE: `${amended}/UpdateAmendedReturn`,
  ADD: `${amended}/AddAmendedReturn`,
  DELETE: `${amended}/DeleteAmendedReturn`,
};

export const ISSUES_ENDPOINTS = {
  ALL_ISSUES_TAB_ENDPOINTS: {
    GET: `${issue}/GetIssueList`,
    GETBYID: `${issue}/GetIssueDetailsByIssueId`,
    DELETE: `${issue}/DeleteIssue`,
    GET_EXCEL: `${issue}/ExportIssueList`,
  },

  NEW_ISSUE_ENDPOINTS: {
    GET_CATE: `${issue}/GetIssueCategories`,
    GET_ISSUE_ID: `${issue}/GenerateIssueId`,
    POST_PUT_ISSUE: `${issue}/AddUpdateIssue`,
  },

  EXISTING_ISSUE_ENDPOINTS: {
    POST: `${issue}/AddNewAdjForIssue`,
    PUT_EDIT: `${filter}/UpdateIssueFilterDetails`,
    PUT_CANCEL: `${filter}/CancelIssueFilterDetails`,
    GET_FILLING: `${issue}/GetARFillingID`,
  },

  FILTERS_ENDPOINTS: {
    POST_GET: `${filter}/GetIssueDetailsByFilter`,
  },
};
